"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributesResolver = exports.validateProductsResolver = exports.patchProductsResolver = exports.getProductsByGroupingCodeResolver = exports.getProductByIdResolver = exports.getProductsResolver = void 0;
const effect_1 = require("effect");
const S = __importStar(require("effect/Schema"));
const gift_core_1 = require("@fixtuur/gift-core");
const HttpClientRequest = __importStar(require("@effect/platform/HttpClientRequest"));
const productAuthoring_1 = require("../../productAuthoring");
const service_1 = require("../service");
const product_type_1 = require("@fixtuur/gift-core/dist/product-type");
const getProductsResolver = (http) => effect_1.RequestResolver.fromEffect((request) => effect_1.Effect.gen(function* () {
    const fetchPage = (params) => http
        .get(`${request.baseUrl}/api/v1/${request.tenant}/products`, { urlParams: params })
        .pipe(effect_1.Effect.flatMap(r => r.json), effect_1.Effect.scoped, effect_1.Effect.flatMap(S.decodeUnknown(gift_core_1.Product.ListProductsResponse)), effect_1.Effect.mapError(e => new service_1.ProductParseError(e, 'Error parsing paginated gift response')));
    const PAGE_SIZE = 200;
    const accumulator = [];
    let cursor = undefined;
    let paginate = true;
    while (paginate) {
        const res = yield* fetchPage({
            cursor,
            limit: PAGE_SIZE,
        });
        accumulator.push(...res.data);
        if (res.data.length < PAGE_SIZE)
            paginate = false;
        cursor = res.next;
    }
    return accumulator;
}));
exports.getProductsResolver = getProductsResolver;
const getProductByIdResolver = (http) => effect_1.RequestResolver.fromEffect((request) => http
    .get(`${request.baseUrl}/api/v1/${request.tenant}/products/${request.productId}`)
    .pipe(effect_1.Effect.mapError(e => new service_1.GetProductRequestError(e)), effect_1.Effect.andThen(r => r.status === 404
    ? effect_1.Effect.fail(new service_1.ProductNotFoundError(request.productId))
    : r.json.pipe(effect_1.Effect.mapError(e => new service_1.GetProductRequestError(e)))), effect_1.Effect.scoped, effect_1.Effect.flatMap(r => S.decodeUnknown(gift_core_1.Product.Product)(r).pipe(effect_1.Effect.mapError(err => new service_1.ProductParseError(err, err.toString()))))));
exports.getProductByIdResolver = getProductByIdResolver;
const getProductsByGroupingCodeResolver = (http) => effect_1.RequestResolver.fromEffect((request) => http
    .get(`${request.baseUrl}/api/v1/${request.tenant}/products`, {
    urlParams: {
        groupingCode: request.groupingCode,
    },
})
    .pipe(effect_1.Effect.andThen(r => r.json), effect_1.Effect.scoped, effect_1.Effect.andThen(S.decodeUnknown(S.Array(gift_core_1.Product.Product))), effect_1.Effect.mapError(e => new service_1.GetProductsError(e))));
exports.getProductsByGroupingCodeResolver = getProductsByGroupingCodeResolver;
// ignores dryRun - intended only for use in the patchProductsResolver
const combineProductsPatch = (a, b) => {
    return {
        updated: effect_1.Array.appendAll(a.updated, b.updated),
        ignored: effect_1.Array.appendAll(a.ignored, b.ignored),
        rejected: effect_1.Array.appendAll(a.rejected, b.rejected),
        upserted: effect_1.Array.appendAll(a.upserted, b.upserted),
    };
};
const patchProductsResolver = (http) => effect_1.RequestResolver.fromEffect((request) => effect_1.Effect.all(effect_1.Array.chunksOf(request.products, 100).map(products => HttpClientRequest.patch(`${request.baseUrl}/api/v1/${request.tenant}/products`, {
    headers: {
        authorization: `Bearer ${request.token}`,
        'content-type': 'application/json',
    },
}).pipe(HttpClientRequest.bodyJson(products), effect_1.Effect.andThen(http.execute), effect_1.Effect.andThen(r => r.json), effect_1.Effect.scoped, effect_1.Effect.andThen(S.decodeUnknown(gift_core_1.Product.ProductPatchResponse)))), { concurrency: 5 }).pipe(effect_1.Effect.map(effect_1.Array.reduce({
    updated: [],
    upserted: [],
    ignored: [],
    rejected: [],
}, combineProductsPatch)), effect_1.Effect.mapError(e => new productAuthoring_1.PatchProductsError(e))));
exports.patchProductsResolver = patchProductsResolver;
const validateProductsResolver = (http) => effect_1.RequestResolver.fromEffect((request) => effect_1.Effect.all(effect_1.Array.chunksOf(request.products, 100).map(products => {
    return HttpClientRequest.post(`${request.baseUrl}/api/v1/${request.tenant}/product-validation`, {
        headers: {
            'Content-Type': 'application/json',
        },
    }).pipe(HttpClientRequest.bodyJson(products), effect_1.Effect.andThen(http.execute), effect_1.Effect.scoped, effect_1.Effect.andThen(r => r.json), effect_1.Effect.mapError(e => new productAuthoring_1.ProductValidationRequestError(`${e}`)), effect_1.Effect.andThen(r => S.decodeUnknown(gift_core_1.Product.ValidationResponseData)(r).pipe(effect_1.Effect.mapError(e => new productAuthoring_1.ProductValidationParseError(request, e)))), effect_1.Effect.map(effect_1.Array.flatMap(r => r.rejected)));
}), { concurrency: 5 }).pipe(effect_1.Effect.map(effect_1.Array.flatten)));
exports.validateProductsResolver = validateProductsResolver;
const getAttributesResolver = (http) => effect_1.RequestResolver.fromEffect((request) => http.get(`${request.baseUrl}/api/v1/product-types`).pipe(effect_1.Effect.andThen(r => r.json), effect_1.Effect.scoped, effect_1.Effect.mapError(e => new productAuthoring_1.AttributesRequestError(`${e}`)), effect_1.Effect.andThen(r => S.decodeUnknown(product_type_1.ProductsAttributesResponse)(r).pipe(effect_1.Effect.mapError(e => new productAuthoring_1.AttributesParseError(request, e)))), effect_1.Effect.map(r => r.productTypes), effect_1.Effect.map(r => r.filter(
/**
 * Filter to only return entries that
 * 1. Have attributes on them
 * 2. Are for the product types we need (as specified in request)
 * */
(x) => !!x.attributes &&
    request.types
        .map(type => type.toLowerCase())
        .includes(x.code.toLowerCase())))));
exports.getAttributesResolver = getAttributesResolver;
